import Vue from 'vue';
import api from '../../utils/api';
import constants from '../constants';
import router from '../../router';
import { moment } from '../../main';

// initial state
const state = {
    loaded: false,
    isCordova: false,
    server: '',
    account: {
    },
    errors: [],
    messages: []
};

// mutations
const mutations = {
    loaded(state, loaded) {
        state.loaded = loaded;
    },
    isCordova(state, isCordova) {
        state.isCordova = isCordova;
    },
    server(state, server) {
        state.server = server;
    },
    account(state, account) {
        state.account = account;
    },
    addError(state, error) {
        state.errors.push(error);
    },
    removeError(state, index) {
        if (index >= 0) {
            state.errors.splice(index, 1);
        }
    },
    addMessage(state, message) {
        state.messages.push(message);
    },
    removeMessage(state, index) {
        if (index >= 0) {
            state.messages.splice(index, 1);
        }
    }
};

// getters
export const getters = {
    server: state => () => {
        return state.server;
    }
};

const functions = {
    signout(store) {
        try {
            localStorage.removeItem(constants.tokenKey);
        } catch (e) {
            //localstorage is not supported (it could be if external cookies are turned off and you are running app in iframe)
        }
        Vue.http.headers.common['Authorization'] = '';
        router.replace({ name: 'signin' });
    },
    initAccount(store) {
        api.get(`/api/account/`).then(function(response) {
                const account = response.body;
                store.commit('account', account);

                store.dispatch('translation/init', account.culture, { root: true });
                moment.locale(account.culture);
                moment.tz.setDefault(account.timezone);

                store.commit('loaded', true);
            },
            function() {
            });
    }
};

// actions
const actions = {
    initAccount(store) {
        functions.initAccount(store);
    },
    init(store, payload) {
        let culture = constants.culture;

        //Detecting supported cultures from device/browser settings
        if (window.Intl && typeof window.Intl === 'object') {
            if (navigator.language.lastIndexOf('ru', 0) === 0) {
                // culture = 'ru';
            } else if (navigator.language.lastIndexOf('de', 0) === 0) {
                culture = 'de';
            }
        }

        //initializing translations with detected culture
        store.dispatch('translation/init', culture, { root: true });

        payload.isCordova = true;//for testing
        store.commit('isCordova', payload.isCordova);
        if (store.state.isCordova) {
            store.commit('server', constants.server);
        }

        //Sending js errors to server for logging
        Vue.config.errorHandler = function (err, vm /*,info*/) {
            let path = '';
            if (vm && vm.$route && vm.$route.fullPath) {
                path = vm.$route.fullPath;
            }
            api.post(`/api/error/log`,
                {
                    message: err.message + ' at ' + path,
                    exception: err.stack
                });
        }

        Vue.http.headers.common['X-Requested-With'] = 'XMLHttpRequest';
        Vue.http.headers.common['Cache-Control'] = 'no-cache';
        Vue.http.headers.common['Pragma'] = 'no-cache';
        Vue.http.interceptors.push(function (request, next) {
            next(function (response) {
                if (response.status === 401) {
                    store.dispatch('settings/signout',
                        null,
                        { root: true });
                }

                //If server returns new token to prolong user session we use it in new requests
                const newToken = response.headers.get('x-vue-mobile-refresh-token');
                if (newToken) {
                    Vue.http.headers.common['Authorization'] = 'Bearer ' + newToken;
                    try {
                        const authorizationDataString = localStorage.getItem(constants.tokenKey);
                        if (authorizationDataString) {
                            const authorizationData = JSON.parse(authorizationDataString);
                            authorizationData.token = newToken;
                            localStorage.setItem(constants.tokenKey, JSON.stringify(authorizationData));
                        }
                    } catch (e) {
                        //localstorage is not supported (it could be if external cookies are turned off and you are running app in iframe)
                    }
                }
            });
        });

        //Getting authorization data from localstorage
        let authorizationData = null;
        let authorizationDataString = null;

        try {
            authorizationDataString = localStorage.getItem(constants.tokenKey);
        } catch (e) {
            //localstorage is not supported (it could be if external cookies are turned off and you are running app in iframe)
        }

        if (authorizationDataString) {
            authorizationData = JSON.parse(authorizationDataString);
        }
        if (!authorizationData) {
            functions.signout(store);
            store.commit('loaded', true);
        } else {
            Vue.http.headers.common['Authorization'] = 'Bearer ' + authorizationData.token;
            functions.initAccount(store);
        }
    },
    save(store, payload) {
        api.put(
            '/api/account/',
            {
                timezone: payload.timezone,
                culture: payload.culture
            }).then(
            function() {
                functions.initAccount(store);
            },
            function() {
            });
    },
    signout(store) {
        functions.signout(store);
    },
    openDashboard() {
        router.push({
            name: 'dashboard'
        });
    },
    addError(store, error) {
        store.commit('addError', error);
        setTimeout(() => {
            store.commit('removeError', store.state.errors.indexOf(error));
        },
            3000);
    },
    removeError(store, index) {
        store.commit('removeError', index);
    },
    addMessage(store, message) {
        store.commit('addMessage', message);
        setTimeout(() => {
            store.commit('removeMessage', store.state.messages.indexOf(message));
        },
            3000);
    },
    removeMessage(store, index) {
        store.commit('removeMessage', index);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/settings.js